<script>
import { PhxLightbox } from '@phx-styleguides/als';
import LightBoxMixin from '@phoenix/mixins/components/product/LightBoxMixin';

export default {
  components: {
    PhxLightbox,
  },
  mixins: [LightBoxMixin],
};
</script>

<template>
  <phx-lightbox :id="lightBoxId" teleport-target="teleport-target-panels" :items="items" :loop="loop" :i18n="i18n" />
</template>
